import { render } from "./IconSelector.vue?vue&type=template&id=5136c9c0&scoped=true"
import script from "./IconSelector.vue?vue&type=script&lang=js"
export * from "./IconSelector.vue?vue&type=script&lang=js"

import "./IconSelector.vue?vue&type=style&index=0&id=5136c9c0&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5136c9c0"]])

export default __exports__